import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: false,
  AADAuthenticateUrl:'Auth/AuthenticateAAD?state=',

  AuthURL: 'https://auth-css-fe-uat.emea.intra.acer.com/SSO/Login',
  APIBaseUrl: 'https://auth-css-be-uat.emea.intra.acer.com/api/',
  AuthAPIBaseUrl: 'https://auth-css-be-uat.emea.intra.acer.com/api/',
  Culture: 'en-US',
  DateFormat: 'yyyy/MM/dd',
  DateTimeFormat: 'yyyy/MM/dd HH:mm:ss',
  ApplicationID: 'CSSAuth',
  AuthCode: '7ScUZAyf',
  DebugLevel: NgxLoggerLevel.WARN,  // TRACE|DEBUG|INFO|LOG|WARN|ERROR|FATAL|OFF
  Title: 'Auth - Global Service System'
};
